import { ColumnsSpec } from '../types';
import { Icon } from '@/new/components/icon';
import { Label } from '@/new/components/shadcn/label';
import {
  MultiSelect,
  MultiSelectContent,
  MultiSelectItem,
  MultiSelectTrigger,
  MultiSelectValue,
} from '@/new/components/shadcn/multi-select';
import { CHIP_COLOURS } from '@/new/lib/chip-colours';

interface Props {
  spec: ColumnsSpec;
  columns: string[];
  onColumnsChange: (columns: string[]) => void;
  relativityColumns: string[];
  onRelativityColumnsChange: (columns: string[]) => void;
}

export const ColumnsField = ({
  spec,
  columns,
  onColumnsChange,
  relativityColumns,
  onRelativityColumnsChange,
}: Props) => (
  <>
    <div className="flex flex-col gap-2">
      <Label className="text-sm font-medium text-gray-700">Select Columns</Label>
      <MultiSelect values={columns} onValuesChange={onColumnsChange}>
        <MultiSelectTrigger className="w-full">
          <MultiSelectValue placeholder="Select columns" />
        </MultiSelectTrigger>
        <MultiSelectContent>
          {spec.available.map((column) => (
            <MultiSelectItem key={column} value={column}>
              {column}
            </MultiSelectItem>
          ))}
        </MultiSelectContent>
      </MultiSelect>
    </div>

    {spec.relativity && spec.relativity.length > 0 && (
      <div className="flex flex-col gap-2">
        <Label className="flex items-center gap-2 text-sm font-medium text-purple-500">
          <Icon className="lucide--database" /> Relativity Metadata Columns
        </Label>
        <MultiSelect values={relativityColumns} onValuesChange={onRelativityColumnsChange}>
          <MultiSelectTrigger className="w-full">
            <MultiSelectValue className={CHIP_COLOURS.relativity} placeholder="Select metadata columns" />
          </MultiSelectTrigger>
          <MultiSelectContent>
            {spec.relativity.map((field) => (
              <MultiSelectItem key={field.fieldName} value={field.fieldName}>
                {field.displayName}
              </MultiSelectItem>
            ))}
          </MultiSelectContent>
        </MultiSelect>
      </div>
    )}
  </>
);
